"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _envConstants = require("../../../../../env-constants");
var _config = require("../../../../../content/config");
var _Link = _interopRequireDefault(require("../../../../Link/Link"));
var _reactCollapsible = _interopRequireDefault(require("react-collapsible"));
var _constants = require("../../../../constants");
var _Svg = _interopRequireDefault(require("../../../../Svg/Svg"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Content = function Content(_ref) {
  var links = _ref.links,
    bookingSearchAction = _ref.bookingSearchAction;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    openId = _useState2[0],
    setOpenId = _useState2[1];
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-u-font-secondary"
  }, bookingSearchAction && /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-md padding-top-sm padding-bottom-sm bg-white d8-u-radius-md text-bold shadow-sm margin-bottom-sm mobile-link-primary",
    onClick: bookingSearchAction
  }, _config.bookingLink[_envConstants.ENV.SITE].text), !bookingSearchAction && /*#__PURE__*/_react["default"].createElement(_Link["default"], {
    className: "d8-u-color-contrast-high",
    href: _config.bookingLink[_envConstants.ENV.SITE].link
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "padding-md padding-top-sm padding-bottom-sm bg-white d8-u-radius-md text-bold shadow-sm margin-bottom-sm mobile-link-primary"
  }, _config.bookingLink[_envConstants.ENV.SITE].text)), links && /*#__PURE__*/_react["default"].createElement("div", null, links.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !!link.nested && link.nested.length > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "d8-c-collapse-mobile-nav"
    }, /*#__PURE__*/_react["default"].createElement(_reactCollapsible["default"], {
      open: openId === index,
      handleTriggerClick: function handleTriggerClick() {
        return setOpenId(function (openId) {
          return index === openId ? null : index;
        });
      },
      className: "d8-c-collapse-original padding-md padding-top-sm padding-bottom-sm bg-white d8-u-radius-md text-bold shadow-sm margin-bottom-sm",
      openedClassName: "d8-c-collapse-original padding-md padding-top-sm padding-bottom-sm bg-white d8-u-radius-md text-bold shadow-sm margin-bottom-sm",
      trigger: link.label,
      triggerTagName: "header",
      easing: _constants.EASING.BOUNCE(),
      transitionTime: 200
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "d8-c-collapse--content padding-top-md"
    }, link.nested.map(function (nestedLink) {
      return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
        key: "".concat(JSON.stringify(nestedLink), "-mobile"),
        className: "d8-u-color-black margin-bottom-sm flex items-center ".concat(nestedLink.bgColor && nestedLink.bgColor + ' featured d8-u-radius-md'),
        href: nestedLink.href,
        external: nestedLink.externalLink
      }, nestedLink.icon && /*#__PURE__*/_react["default"].createElement(_Svg["default"], {
        name: nestedLink.icon,
        className: "margin-right-xxs icon--sm",
        fill: _constants.COLORS.BLACK
      }), /*#__PURE__*/_react["default"].createElement("div", null, nestedLink.label.replace(/<[^>]*>?/gm, '').split(',')[0], /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-color-contrast-high block font-light"
      }, nestedLink.label.replace(/<[^>]*>?/gm, '').split(',')[1])));
    })))) : /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: "".concat(JSON.stringify(link), "-mobile"),
      className: "d8-u-color-black",
      href: link.href,
      external: link.externalLink
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "padding-md padding-top-sm padding-bottom-sm bg-white d8-u-radius-md text-bold shadow-sm margin-bottom-sm"
    }, link.label)));
  })));
};
Content.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].object),
  toggle: _propTypes["default"].func,
  bookingSearchAction: _propTypes["default"].func
};
var _default = exports["default"] = Content;